import { Button, Group } from '@mantine/core';
import { NewSuitabilityData } from '../types';

type Props = {
  data: NewSuitabilityData;
  setData: React.Dispatch<React.SetStateAction<NewSuitabilityData>>;
};

export function ClientFamilyToggle({ data, setData }: Props) {
  const switchToClientMode = () => {
    setData(prev => {
      if (!prev.isFamily) return prev;
      return {
        flowId: prev.flowId,
        adviceFiles: prev.adviceFiles,
        optimiseAdviceReadability: prev.optimiseAdviceReadability,
        template: prev.template,
        reportFormat: prev.reportFormat,
        feeDocuments: prev.feeDocuments,
        supportDocuments: prev.supportDocuments,
        highlightedElement: prev.highlightedElement,
        isFamily: false,
        client: undefined,
      };
    });
  };

  const switchToFamilyMode = () => {
    setData(prev => {
      if (prev.isFamily) return prev;
      return {
        flowId: prev.flowId,
        adviceFiles: prev.adviceFiles,
        optimiseAdviceReadability: prev.optimiseAdviceReadability,
        template: prev.template,
        reportFormat: prev.reportFormat,
        feeDocuments: prev.feeDocuments,
        supportDocuments: prev.supportDocuments,
        highlightedElement: prev.highlightedElement,
        isFamily: true,
        family: undefined,
      };
    });
  };

  return (
    <Group justify="space-between" mb="sm">
      <Button.Group>
        <Button variant={data.isFamily ? 'subtle' : 'light'} onClick={switchToClientMode}>
          Clients
        </Button>
        <Button variant={data.isFamily ? 'light' : 'subtle'} onClick={switchToFamilyMode}>
          Families
        </Button>
      </Button.Group>
    </Group>
  );
}
